var _defs, _circle, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightCircledArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.1 142.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: -9,
    y: -8,
    id: "shadow",
    height: 1000,
    width: 1000
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 1,
    stdDeviation: 2,
    floodOpacity: 0.7
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.05,
    cy: 71.05,
    r: 71.05,
    fill: "#f2622e",
    filter: "url(#shadow)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Play",
    points: "56.96 103.55 96.84 71.14 56.96 39.25",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCircledArrow);
export default __webpack_public_path__ + "static/media/rightCircledArrow.91f7a3d057db95b513fa03d4ff538207.svg";
export { ForwardRef as ReactComponent };